import { projectTypes } from '@/Models';
import StoreCard from '@/Components/StoreCard/StoreCard.vue';
import ProjectCard from '@/Components/ProjectCard/ProjectCard.vue';

export function buildProjectCards(projects, {
    decorateUrl,
    decorateImageUrl = (project) => project.imageUrl,
    extraProps = () => ({}),
}) {
    return projects.map((project, index) => {
        const url = decorateUrl(project, index);
        const imageUrl = decorateImageUrl(project, index);
        const extra = extraProps(project, index);

        if (project.type === projectTypes.store) {
            return {
                props: {
                    imageUrl,
                    url,
                    name: project.name,
                    creator: project.creator,
                    projectID: project.projectID,
                    ...extra,
                },
                component: StoreCard,
            };
        }

        return {
            props: {
                ...project,
                imageUrl,
                url,
                ...extra,
            },
            component: ProjectCard,
        };
    });
}
